import { Page, PageSkeleton } from '@/components';
import { useApi } from '@/api';
import { Flex, KpiSkeleton, TableSkeleton, KpiCard } from '@blockanalitica/ui';
import LiquidatorsTable from './LiquidatorsTable';

type LiquidationsStatsResponse = {
  number_of_liquidators: number | null;
  number_of_liquidators_change: number | null;
  number_of_liquidators_change_percentage: number | null;
  collateral_seized_usd: string | null;
  collateral_seized_usd_change: string | null;
  collateral_seized_usd_change_percentage: string | null;
  debt_repaid_usd: string | null;
  debt_repaid_usd_change: string | null;
  debt_repaid_usd_change_percentage: string | null;
  total_profits: string | null;
  total_profits_change: string | null;
  total_profits_change_percentage: string | null;
};
export default function MarketPage() {
  const [data, error] = useApi<LiquidationsStatsResponse>({
    url: `/liquidations/stats/`,
    queryParams: {}
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return (
      <PageSkeleton>
        <Flex gap={['s', 'xs']} flexDirection={['column', 'row']}>
          <KpiSkeleton />
          <KpiSkeleton />
          <KpiSkeleton />
        </Flex>
        <TableSkeleton />
      </PageSkeleton>
    );
  }
  return (
    <Page title="Liquidators">
      <Flex gap={['s', 'xs']} flexDirection={['column', 'row']}>
        <KpiCard
          title="# of Liquidators"
          data={data}
          field="number_of_liquidators"
        />
        <KpiCard
          title="Collateral Liquidated"
          data={data}
          field="collateral_seized_usd"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: 'USD',
                notation: 'compact'
              }
            }
          }}
        />
        <KpiCard
          title="Debt Repaid"
          data={data}
          field="debt_repaid_usd"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: 'USD',
                notation: 'compact'
              }
            }
          }}
        />
        <KpiCard
          title="Liquidator's Profits"
          data={data}
          field="total_profits"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: 'USD',
                notation: 'compact'
              }
            }
          }}
        />
      </Flex>
      <LiquidatorsTable />
    </Page>
  );
}
